module.exports = __webpack_public_path__ + "static/media/1.434bada9.svg";